import {
  SOLUTION_CATEGORIES_LIST,
  SOLUTION_CATEGORY_TYPE_DICTIONARY,
} from '../../utils/selectOptions';
import { TType } from '../../hooks/useTranslation';

type Item = {
  value: string;
  label: string;
};

type Group = {
  label: string;
  items: Item[];
};

export const returnListOfOptions = (t: TType) => {
  const solutionsMap: { [key: string]: Group } = {};
  SOLUTION_CATEGORIES_LIST.forEach((category) => {
    solutionsMap[category] = {
      label: t(`solutionCategories.${category}`),
      items: SOLUTION_CATEGORY_TYPE_DICTIONARY[category]?.map((type) => ({
        value: type,
        label: t(`solutionTypes.${type}`),
      })),
    };
  });
  return solutionsMap;
};

type Data = Record<string, Group>;

export const filterByLabels = (data: Data, searchTerm: string): Data => {
  const query = searchTerm.toLowerCase().trim();

  if (!query) return data;

  return Object.entries(data).reduce((acc, [key, group]) => {
    const groupLabel = group.label.toLowerCase();

    if (groupLabel.includes(query)) {
      acc[key] = group;
      return acc;
    }

    const filteredItems = group.items.filter((item) => {
      const itemLabel = item.label.toLowerCase();

      const isItemLabelMatch = itemLabel.includes(query);

      const isCombinedMatch =
        `${groupLabel} ${itemLabel}`.includes(query) ||
        `${groupLabel} - ${itemLabel}`.includes(query);

      return isItemLabelMatch || isCombinedMatch;
    });

    if (filteredItems.length > 0) {
      acc[key] = {
        ...group,
        items: filteredItems,
      };
    }

    return acc;
  }, {} as Data);
};
